export { default } from './AdvantagesList';
